import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import React, { Component } from 'react';
import { jsx } from '@emotion/react';
import { panelTextInput } from '@atlaskit/editor-common/ui';
// eslint-disable-next-line @repo/internal/react/no-class-components
var TextField = /*#__PURE__*/function (_Component) {
  _inherits(TextField, _Component);
  var _super = _createSuper(TextField);
  function TextField(props) {
    var _this;
    _classCallCheck(this, TextField);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      _this.setState({
        text: e.target.value
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (e) {
      e.preventDefault();
      if (_this.props.onSubmit) {
        _this.props.onSubmit(_this.state.text);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e) {
      e.preventDefault();
      if (_this.props.onBlur) {
        _this.props.onBlur(_this.state.text);
      }
    });
    _this.state = {
      text: props.defaultValue || ''
    };
    return _this;
  }
  _createClass(TextField, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.state.text !== nextProps.defaultValue) {
        this.setState({
          text: nextProps.defaultValue || ''
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var placeholder = this.props.placeholder;
      return jsx("form", {
        onSubmit: this.handleSubmit
      }, jsx("input", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: panelTextInput,
        value: this.state.text,
        onChange: this.handleChange,
        placeholder: placeholder,
        onBlur: this.handleBlur
      }));
    }
  }]);
  return TextField;
}(Component);
export { TextField as default };